import { Icon } from "PFComponents/icon";
import { Tooltip } from "PFComponents/tooltip";
import { Typography } from "PFComponents/typography";
import { useTranslation } from "react-i18next";

import css from "./availability_warning_icon.module.scss";

export const AvailabilityWarningIcon = () => {
  const { t } = useTranslation("activities");

  return (
    <Tooltip
      content={<Typography variant="bodyRegular">{t("show.shortlist.candidateNoLongerMatch")}</Typography>}
      triggerContainerProps={{ className: css.warningIcon }}
    >
      <Icon name="warning" size="sm" color="paletteOrange0" />
    </Tooltip>
  );
};
